<template>
    <div class="product-type-img">
        <ul>
            <li v-for="(category, key) in categorySub" @click="toRun(category.code)">
                <div class="img-li-con">
                    <img :src="categoryImages[category.code]['big']" />
                    <div class="img-text-con"></div>
                    <p>{{ category.value }}</p>
                </div>
            </li>
        </ul>
        <div class="container-both-clear"></div>
    </div>
</template>

<script>
    export default {
        props:{
            categorySub: {
                type: Array,
                default: []
            },
            categoryImages:{
                type: Object,
                default: {}
            }
        },
        data() {
            return {

            }
        },
        computed:{
        },
        methods:{
            toRun(category){
                this.$emit("toProductDetail",category);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .product-type-img{
        position: relative;
        width: 100%;
        ul {
            list-style: none;
            padding-left: 0;
            padding-right: 0;
            li{
                cursor: pointer;
                float: left;
                width: 30%;
                div.img-li-con {
                    position: relative;
                    width: 100%;
                    height: 0;
                    padding-bottom: 100%;
                    img {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                    }
                    div.img-text-con{
                        position: absolute;
                        bottom: 0;
                        background-color: #000;
                        opacity: 0.3;
                        height: 60px;
                        width: 100%;
                        margin-bottom: 0;
                    }
                    p{
                        position: absolute;
                        bottom: 0;
                        margin-bottom: 0;
                        color: #fff;
                        font-size: 18px;
                        font-weight: bold;
                        text-align: center;
                        line-height: 60px;
                        width: 100%;
                        height: 60px;
                    }
                }
            }
            li:nth-child(1){
                margin-right: 2.5%;
            }
            li:nth-child(2){
                margin-right: 2.5%;
                margin-left: 2.5%;
            }
            li:nth-child(3){
                margin-left: 2.5%;
            }
        }
        .container-both-clear{
            clear: both;
            height: 20px;
        }
    }
</style>
